import { message } from "antd";
import React from "react";
import Head from "../components/common/Head";
import MoviesModal from "../components/movies/Modal";
import ContentTable from "../components/movies/Table";
import useValidate from "../hooks/useValidate";
import { getAllGenres, getAllSeries } from "../utils/api";

const Series = () => {
  const [series, setSeries] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [modal2, setModal2] = React.useState(false);
  const [update, setUpdate] = React.useState({});
  const [genres, setGenres] = React.useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const getAllGenresData = async () => {
    setLoading(true);
    const [success, response] = await getAllGenres();
    if (success) setGenres(response);
    setLoading(false);
  };

  useValidate();
  const getAllSeriesData = async () => {
    setLoading(true);
    const [success, response] = await getAllSeries();
    if (success) setSeries(response);
    setLoading(false);
  };

  React.useEffect(() => {
    getAllSeriesData();
    getAllGenresData();
  }, []);
  return (
    <>
      {contextHolder}
      <Head
        title="Series"
        button={"Add Series"}
        onClick={() => setModal(true)}
      />
      <ContentTable
        data={series}
        loading={loading}
        setModal2={setModal2}
        setUpdate={setUpdate}
        series
        messageApi={messageApi}
        reload={getAllSeriesData}
      />

      <MoviesModal
        modal={modal}
        setModal={setModal}
        series
        reload={getAllSeriesData}
        genres={genres}
        messageApi={messageApi}
      />
      <MoviesModal
        modal={modal2}
        setModal={setModal2}
        series
        reload={getAllSeriesData}
        genres={genres}
        update={update}
        messageApi={messageApi}
      />
    </>
  );
};

export default Series;
